import * as React from 'react'

import { LocalDebug } from 'common/Local'
import { BoardPage } from 'components/boardPage/BoardPage';
import { BoardConfigPage } from 'components/boardConfigPage/ConfigPage';

if (process.env.REACT_APP_ENVIROMENT === 'local') {
  // ローカル環境用クラスを生成
  new LocalDebug()
} else {
  // ローカルのときだけlogを流します
  console.log = () => { }
}

class App extends React.Component {
  render() {
    switch (process.env.REACT_APP_PAGE_KEY) {
      case 'board':
        return <BoardPage />
      case 'config':
        return <BoardConfigPage />
      default:
        return <></>
    }
  }
}

export default App
